import { openDB,deleteDB } from 'idb';
import axios from 'axios';
import store from '../store';
import * as Sentry from '@sentry/browser';

const DB_NAME = 'cluvi-vue';
const DB_VERSION = 1;
const STORE_CONTENT_HOME = 'content_home';
const STORE_CATEGORIES = 'categories';
const STORE_PRODUCTS = 'products';
const STORE_UPSELLING = 'upselling_products';
const STORE_MASTERS = 'master_product_ids';

function getDeviceAndVersion () {
  var esDispositivoMovil = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  var sistemaOperativo = navigator.platform;
  if (esDispositivoMovil && sistemaOperativo === 'iPhone') {
    var userAgent = navigator.userAgent;
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      var iOSVersion = userAgent.match(/OS\s([0-9._]+)/);
      if (iOSVersion) return parseFloat(iOSVersion[1].replace(/_/g, '.'));
    } else {
      console.error("No se puede determinar la versión del sistema operativo.");
    };
  }
};
getDeviceAndVersion();

const dbFunctions = {
  openDB: async () => {
    //console.log("run openDB")
    try {
      const db = await openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
          //almacenamientos de datos
          const contentHome = db.createObjectStore(STORE_CONTENT_HOME, { keyPath: "id", autoIncrement: true });
          const categories = db.createObjectStore(STORE_CATEGORIES, { keyPath: "id", autoIncrement: true });
          const products = db.createObjectStore(STORE_PRODUCTS, { keyPath: "id", autoIncrement: true });
          const upsellingProducts = db.createObjectStore(STORE_UPSELLING, { keyPath: "id", autoIncrement: true });
          const masterProductIds = db.createObjectStore(STORE_MASTERS, { keyPath: "id", autoIncrement: true });
          //Indexs
          contentHome.createIndex("contentHomeIndex", ["layout_type","order"], { unique: false, multiEntry: false });
          categories.createIndex("categoriesIndex",["type","order"],{ unique: false, multiEntry: false });
          products.createIndex("productsIndex", ["product_id"], { unique: false, multiEntry: false });
          upsellingProducts.createIndex("upsellingProductsIndex", ["label_popup"], { unique: false, multiEntry: false });
          masterProductIds.createIndex("masterProductIdsIndex", ["id"], { unique: false, multiEntry: false });
        }
      });
      return db;
    } catch (error) {
      console.error(error);
      throw new Error('Error al abrir la base de datos');
    }
  },
  saveDataContentHome: async (data) => {
    //console.log("run saveDataContentHome")
    const db = await dbFunctions.openDB();
    try {
      const tx = db.transaction([STORE_CONTENT_HOME], "readwrite");
      const store = tx.objectStore(STORE_CONTENT_HOME);
      //setear actualizado a false
      const homes = await store.getAll()
      homes.map(async x => { x.updated = false; await store.put(x) });
      //setear actualizado a false
      data.content_home.map(async x => { x.updated = true; await store.put(x) });
      //BorrarRegistros registros
      const homes2 = await store.getAll()
      homes2
      .filter(x => x.updated === false)
      .map(async x => { await store.delete(x.id) });
      tx.complete;
    } catch (error) {
      console.error(error);
      Sentry.captureException(error);
      throw new Error('Error al actualizar los datos de contentHomes');
    };
  },
  saveDataCategories: async (data) => {
    //console.log("run saveDataCategories")
    const db = await dbFunctions.openDB();
    try {
      const tx = db.transaction([STORE_CATEGORIES], "readwrite");
      const store = tx.objectStore(STORE_CATEGORIES);
      //setear actualizado a false
      const categories = await store.getAll()
      categories.map(async x => { x.updated = false; await store.put(x) });
      //Actualizar registros
      data.menu.categories.map(async x => { await store.put(x) });
      //BorrarRegistros registros
      const categories2 = await store.getAll()
      categories2
      .filter(x => x.updated === false)
      .map(async x => { await store.delete(x.id) });
      tx.complete;
    } catch (error) {
      console.error(error);
      Sentry.captureException(error);
      throw new Error('Error al actualizar los datos de categories');
    };
  },
  saveDataProducts: async (data) => {
    //console.log("run saveDataProducts")
    const db = await dbFunctions.openDB();
    try {
      const tx = db.transaction([STORE_PRODUCTS], "readwrite");
      const store = tx.objectStore(STORE_PRODUCTS);
      //setear actualizado a false
      const products = await store.getAll()
      products.map(async x => { x.updated = false; await store.put(x) });
      //Actualizar registros
      data.menu.products.map(async x => { await store.put(x) });
      //BorrarRegistros registros
      const products2 = await store.getAll()
      products2
      .filter(x => x.updated === false)
      .map(async x => { await store.delete(x.id) });
      tx.complete;
    } catch (error) {
      console.error(error);
      Sentry.captureException(error);
      throw new Error('Error al actualizar los datos de products');
    };
  },
  saveDataUpselling: async (data) => {
    //console.log("run saveDataUpselling")
    const db = await dbFunctions.openDB();
    try {
      const tx = db.transaction([STORE_UPSELLING], "readwrite");
      const store = tx.objectStore(STORE_UPSELLING);
      
      //setear actualizado a false
      const upsellings = await store.getAll()
      upsellings.map(async x => { x.updated = false; await store.put(x) });

      //Actualizar registros
      data.upselling_products.map(async x => { await store.put(x) });

      //BorrarRegistros registros
      const upsellings2 = await store.getAll()
      upsellings2
      .filter(x => x.updated === false)
      .map(async x => { await store.delete(x.id) });

      tx.complete;
    } catch (error) {
      console.error(error);
      Sentry.captureException(error);
      throw new Error('Error al actualizar los datos de Upselling');
    };
  },
  saveDataMasters: async (data) => {
    //console.log("run saveDataMasters")
    const db = await dbFunctions.openDB();
    try {
      const tx = db.transaction([STORE_MASTERS], "readwrite");
      const store = tx.objectStore(STORE_MASTERS);
      data.master_product_ids.map(async x => { await store.put(x) });
      tx.complete;
    } catch (error) {
      console.error(error);
      Sentry.captureException(error);
      throw new Error('Error al actualizar los datos de maters');
    };
  },
  saveData: async (data) => {
    //console.log("run saveData")
    dbFunctions.saveDataContentHome(data);
    dbFunctions.saveDataCategories(data);
    dbFunctions.saveDataProducts(data);
    dbFunctions.saveDataUpselling(data);
    if(data.master_product_ids)
      dbFunctions.saveDataMasters(data);
    
  },
  openStoreAndCreateTransaction: (storeName, action) => {
    //console.log("run openStoreAndCreateTransaction")
    return dbFunctions.openDB()
      .then(db => {
        const tx = db.transaction(storeName, action);
        return tx.objectStore(storeName);
      }).catch(error => {
        Sentry.captureException(error);
        throw new Error('Error al abrir la tienda y crear transacción: ' + error);
      });
  },
  contentHomeData: () => {
    //console.log("run contentHomeData")
    return dbFunctions.openStoreAndCreateTransaction(STORE_CONTENT_HOME, 'readonly')
      .then(store => {
        //console.log("contentHomeData return")
        const data = store.getAll();
        //console.log(data)
        return data;
      }).catch(error => {
        Sentry.captureException(error);
        throw new Error('Error al obtener datos de contentHome: ' + error);
      });
  },
  getProducts: (product_id) => {
    //console.log("run getProducts")
    return dbFunctions.openStoreAndCreateTransaction(STORE_PRODUCTS, 'readonly')
      .then(store => {
        const iosVersion = getDeviceAndVersion();
        const index = store.index('productsIndex');
        let data = iosVersion && iosVersion < 17 ? product_id : [product_id];
        return index.getAll(data);
      }).catch(error => {
        Sentry.captureException(error);
        throw new Error('Error al obtener productos: ' + error);
      });
  },
  getCategoriesIDB: () => {
    //console.log("run getCategoriesIDB")
    return dbFunctions.openStoreAndCreateTransaction(STORE_CATEGORIES, 'readonly')
      .then(store => {
        const index = store.index('categoriesIndex');
        return index.getAll();
      }).catch(error => {
        Sentry.captureException(error);
        throw new Error('Error al obtener categorías: ' + error);
      });
  },
  getMainCategorieIDB: (id) => {
    //console.log("run getMainCategorieIDB")
    return dbFunctions.openStoreAndCreateTransaction(STORE_CATEGORIES, 'readonly').then(store => {
      return store.get(id);
    }).catch(error => {
      Sentry.captureException(error);
      throw new Error('Error al obtener la categoría principal: ' + error);
    });
  },
  getMasterProductsIds: () => {
    //console.log("run getMasterProductsIds")
    return dbFunctions.openStoreAndCreateTransaction(STORE_MASTERS, 'readonly')
      .then(store => {
        return store.getAll();
      }).catch(error => {
        Sentry.captureException(error);
        throw new Error('Error al obtener datos de contentHome: ' + error);
      });
  },
  deleteDataBaseIDB: () => {
    //console.log("run deleteDataBaseIDB")
    return dbFunctions.openDB(DB_NAME)
      .then((db) => {
        store.state.ontable.flatSavedDataIndexedDb = false;
        db.close();
        return deleteDB(DB_NAME);
      })
      .catch((error) => {
        Sentry.captureException(error);
        throw new Error('Error al intentar eliminar la base de datos:' + error);
      });
  },
  menuCache: () => {
    //console.log("run menuCache")
    return new Promise((resolve, reject) => {
        dbFunctions.getMenuCache(store.state.customer.supplier.id, store.state.order.service, store.state.order.subservice, 'en-menu', store.state.shared.lang)
          .then(response => {
            if (response) dbFunctions.insertData(response.data);
            resolve(response.data);
          })
          .catch(error => {
            (error);
            return dbFunctions.getMenuNonCache(store.state.customer.supplier.id, store.state.order.service, store.state.order.subservice, 'en-menu', store.state.shared.lang)
              .then(response => {
                if (response) dbFunctions.insertData(response.data);
                resolve(response.data);
              })
              .catch(error => {
                Sentry.captureException(error);
                reject(error);
              });
          });
    });
  },
  getReloadMenuCache: () => {
    //console.log("run getReloadMenuCache")
    return new Promise((resolve, reject) => {
        dbFunctions.getMenuCache(store.state.customer.supplier.id, store.state.order.service, store.state.order.subservice, 'en-menu', store.state.shared.lang)
          .then(response => {
            if (response) dbFunctions.insertData(response.data);
            resolve(response.data);
          })
          .catch(error => {
            console.error(error);
            Sentry.captureException(error);
            reject(error);
          });
    });
  },
  insertData: (data) => {
    //console.log("run insertData")
    for (let product of data.menu.products) {
      product.product_id = product.id;
      product.id = product.product_supplier_id;
    };
    
    dbFunctions.saveData(data);
   
  },
  getMenuCache: (supplier_id,service,subservice,trigger,lang) => {
    let url = process.env.VUE_APP_NEW_API_CACHE;
    if(!store.state.customer.instance.menu_cached) url = process.env.VUE_APP_NEW_API_NONCACHE;
    return axios({
      method: "get",
      url: `${url}/v1/menu/${supplier_id}/${service}${subservice ? `/${subservice}.json` : ".json"}?lang=${lang || 'es'}`.trim()
    });
  },
  getMenuNonCache: (supplier_id,service,subservice,trigger,lang) => {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_NEW_API_NONCACHE}/v1/menu/${supplier_id}/${service}${subservice ? `/${subservice}.json` : ".json"}?lang=${lang || 'es'}`.trim()
    });
  }
};

export {
  dbFunctions
}